module.exports = __webpack_public_path__ + "img/ht.28f07f9.svg";